import Button from 'components/atoms/Button/Button'
import * as FormConst from 'constants/FormConst'
import RouteConst from 'constants/RouteConst'
import SessionConst from 'constants/SessionConst'
import SideNavEntryMapping from 'constants/SideNavEntryMapping'
import StringConst from 'constants/StringConst'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import { getBrandLogo } from 'utilities/FormHelper'
import { getSessionItem } from 'utilities/SessionHelper'
import ProgressBar from '../../../atoms/ProgressBar/ProgressBar'
import RecapService from 'services/RecapService'
import FormModal from '../../FormModal/FormModal'
import * as RoleConfigurationConst from 'constants/RoleConfigurationConst'
import { isArrayIncludesAny } from '../../../../utilities/JSUtil'
import './FormHeader.scss'
import * as ErrorConst from "../../../../constants/ErrorConst";

export class FormHeader extends Component {

    readOnlyMessages = {
        [FormConst.STATUS_READY_FOR_REVIEW]: FormConst.IS_READY_FOR_REVIEW_READ_ONLY_MODE_TEXT,
        [FormConst.STATUS_UNDER_REVIEW]: FormConst.IS_UNDER_REVIEW_SUBMITTED_READ_ONLY_MODE_TEXT,
        [FormConst.STATUS_COMPLETED]: FormConst.IS_COMPLETE_READ_ONLY_MODE_TEXT,
        [FormConst.STATUS_CLOSED]: FormConst.IS_CLOSED_READ_ONLY_MODE_TEXT
    }

    constructor(props) {
        super(props)
        const user = getSessionItem(SessionConst.USER)
        const currentUser = user.username
        const isReadOnlyUser = user.isReadOnlyUser
        const isSubmitted = getSessionItem(SessionConst.IS_SUBMITTED) === FormConst.VALUE_YES ? true : false
        let isReadOnlyMode = getSessionItem(SessionConst.IS_READ_ONLY) === FormConst.VALUE_YES ? true : false
        const lockOwner = getSessionItem(SessionConst.LOCK_OWNER)

        const isAdmin = user?.isAdmin
        const isFranchiseCareUser = user.isFranchiseCareUser

        const jobRoles = user.jobRoles
        const isDistributionUser = isArrayIncludesAny(jobRoles, RoleConfigurationConst.DISTRIBUTION_USER_ROLE)

        const rolesAllowedToReviewComplete = [RoleConfigurationConst.AREA_DIRECTOR_ROLE, RoleConfigurationConst.REVENUE_MANAGER_ROLE]
        const isAbleToReviewComplete = isArrayIncludesAny(jobRoles, rolesAllowedToReviewComplete)

        //if Read only flag is modified inside feedback page, we set it here back to true to don't modify what the user can do in the rest of the pages
        if(isAbleToReviewComplete && isReadOnlyUser) {
            isReadOnlyMode = true
        }
        const propelRoles = user.propelRoles
        const isFullAccessUser = isArrayIncludesAny(propelRoles, RoleConfigurationConst.FULL_ACCESS_PROPEL_ROLE)

        const readOnlyMessage = isReadOnlyUser
            ? FormConst.IS_READ_ONLY_USER_TEXT + `(${currentUser})`
            : (isSubmitted
                ? this.readOnlyMessages[props.onboardingStatus]
                : FormConst.IS_LOCKED_READ_ONLY_MODE_TEXT + lockOwner)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)
        const hotelInfo = (hotelInfoCompletedHistory?.newEntity &&
                           hotelInfoCompletedHistory?.newEntity?.status === "COMPLETED") ? hotelInfoCompletedHistory?.newEntity.hotelInfo
                          : props.hotelInfo
        this.state = {
            isSubmitted: isSubmitted,
            lockOwner: lockOwner,
            isReadOnlyUser: isReadOnlyUser,
            isReadOnlyMode: isReadOnlyMode,
            readOnlyMessage: readOnlyMessage,
            isAdmin: isAdmin,
            isAbleToReviewComplete: isAbleToReviewComplete,
            isFranchiseCareUser: isFranchiseCareUser,
            isDistributionUser: isDistributionUser,
            isFullAccessUser: isFullAccessUser,
            currentUser: currentUser,
            showRecapConfirmation: false,
            successfulRecap: false,
            recapError: false,
            hotelInfo: hotelInfo
        }

        this.doRecap = this.doRecap.bind(this)
    }

    redirectToForm = () => {
        this.props.history.goBack()
    }

    redirectToFeedbackPage = () => {
        this.props.history.push(RouteConst.ROUTE_FEEDBACK_PAGE)
    }

    doRecap = () => {
        this.setState({ showRecapConfirmation: false })
        
        RecapService.postRecap(this.state.hotelInfo.hotelCode)
            .then(() => {
                this.setState({ successfulRecap: true })
            }).catch(error => {
                let hotelStatusNotValid = error.messages.find(
                    e => e.code === ErrorConst.ERROR_CODE_HOTEL_STATUS_NOT_VALID_IN_HDS)?.code;
                if (hotelStatusNotValid) {
                    this.setState({ errorMessage: FormConst.MODAL_RECAP_INVALID_STATUS_ERROR_TEXT });
                }
                this.setState({ recapError: true })
            })
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.onboardingStatus !== this.props.onboardingStatus) {
            const readOnlyMessage = this.state.isReadOnlyUser
                ? FormConst.IS_READ_ONLY_USER_TEXT + `(${this.state.currentUser})`
                : (this.state.isSubmitted
                    ? this.readOnlyMessages[this.props.onboardingStatus]
                    : FormConst.IS_LOCKED_READ_ONLY_MODE_TEXT + this.state.lockOwner)

            this.setState({
                readOnlyMessage: readOnlyMessage
            })
        }
    }

    render() {
        let logo = <img className="form-header-brand" src={getBrandLogo(this.state.hotelInfo)} width={140} />

        const isFeedbackPage = this.props.selectedFormTitle === SideNavEntryMapping.FEEDBACK.current.title
        const feedbackLinkText = isFeedbackPage
            ? FormConst.BACK_TO_FORM_LINK_TEXT
            : this.state.isAdmin || this.state.isAbleToReviewComplete && (this.props.onboardingStatus === FormConst.STATUS_UNDER_REVIEW ||
                                                                           this.props.onboardingStatus === FormConst.STATUS_REVIEW_COMPLETE)
                ? FormConst.FEEDBACK_LINK_TEXT_ADMIN : FormConst.FEEDBACK_LINK_TEXT_NON_ADMIN

        return (
            <Row className="form-header">
                <Col className="d-none d-lg-block form-header-empty-column" lg={3}></Col>
                <Col xs={12} lg={9} className="form-header-column">
                    <div className="form-header-data">
                        <Row className='d-flex align-items-center'>
                            <Col xs={4} lg={6} xl={3}>{logo}</Col>
                            <Col xs={8} lg={6} xl={9}>
                                {
                                    this.state.hotelInfo && (
                                        <span className="form-header-hotel-info">
                                            <span className="hotel-name">
                                                {this.state.hotelInfo.hotelName}
                                            </span>
                                            <br />
                                            <span className="hotel-code">
                                                Hotel code: <span className='text-bold'>{this.state.hotelInfo.hotelCode}</span>
                                            </span>
                                            <br />
                                            <span className="brand-code">
                                                Brand: <span className='text-bold'>{this.state.hotelInfo.brandName}</span>
                                            </span>
                                            <br />
                                            {
                                                this.state.hotelInfo.address
                                                && <span className="hotel-address">
                                                    {this.state.hotelInfo.address.line1 && <>{this.state.hotelInfo.address.line1}<br /></>}
                                                    {this.state.hotelInfo.address.line2 && <>{this.state.hotelInfo.address.line2}<br /></>}
                                                    {this.state.hotelInfo.address.city && <>{this.state.hotelInfo.address.city},{StringConst.NBSP}</>}
                                                    {this.state.hotelInfo.address.state && <>{this.state.hotelInfo.address.state},{StringConst.NBSP}</>}
                                                    {this.state.hotelInfo.address.country}
                                                    {StringConst.NBSP}
                                                    {this.state.hotelInfo.address.postalCode}
                                                </span>
                                            }
                                        </span>
                                    )
                                }
                            </Col>
                        </Row>


                    </div>
                    <br />
                    {this.state.isReadOnlyMode && <h5 className='error'>{this.state.readOnlyMessage}</h5>}
                    <div className='form-header-progress-bar'>
                        <ProgressBar now={this.props.progress} status={this.props.onboardingStatus} />
                    </div>
                    <br />
                    <Row className="form-header-title text-center align-items-center">
                        <Col xs={12} lg={{ span: 4, offset: 3 }} xl={{ span: 7, offset: 2 }} className='d-flex justify-content-center'>{this.props.selectedFormTitle}</Col>
                        <Col xs={12} lg={4} xl={3}>
                            
                            <Button overridedisabledflag='true' role='link' name={feedbackLinkText} className='feedback-link' onClick={() => {
                                    if (isFeedbackPage) {
                                        this.redirectToForm()
                                    } else {
                                        this.redirectToFeedbackPage()
                                    }
                                }} />

                            {
                                this.props.onboardingStatus === FormConst.STATUS_COMPLETED
                                    && this.state.isFullAccessUser
                                    && (this.state.isFranchiseCareUser || this.state.isDistributionUser)
                                ? (
                                    <Button id='recap-link' 
                                        className= 'recap-link' 
                                        role='link' 
                                        name={FormConst.RECAP_LINK_TEXT}
                                        overridedisabledflag='true'
                                        onClick={() => this.setState({ showRecapConfirmation: true }) } />
                                ) : (
                                    <></> 
                                )
                            }
                        </Col>
                    </Row>

                </Col>

                <FormModal
                    id='recap-confirmation-modal'
                    title={FormConst.RECAP_LINK_TEXT}
                    body={<h6>{FormConst.MODAL_RECAP_CONFIRMATION_TEXT}</h6>}
                    hotelInfo={this.state.hotelInfo}
                    show={this.state.showRecapConfirmation}
                    proceed={() => this.doRecap()}
                    cancel={() => this.setState({ showRecapConfirmation: false }) } />

                <FormModal
                    id='recap-error-modal'
                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                    body={<h5>{FormConst.MODAL_RECAP_ERROR_TEXT}</h5>}
                    hotelInfo={this.state.hotelInfo}
                    show={this.state.recapError}
                    errorMessage={this.state.errorMessage}
                    cancel={() => this.setState({ recapError: false }) }
                    isError />

                <FormModal
                    id='recap-success-modal'
                    title={FormConst.RECAP_LINK_TEXT}
                    body={<h5>{FormConst.MODAL_RECAP_SUCCESS_TEXT}</h5>}
                    hotelInfo={this.state.hotelInfo}
                    show={this.state.successfulRecap} 
                    cancel={() => this.setState({ successfulRecap: false }) }/>
            </Row>
        )
    }
}

export default withRouter(FormHeader)
